const Theme = localStorage.getItem('Theme');

export default [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'NODE_LOGIN',
    },
    component: () => import(/* webpackChunkName: "Account" */'@/modules/FPKG-40000-Account/login/login.vue'),
  },

  {
    path: '/account',
    component: () => import(/* webpackChunkName: "Account" */`@/modules/FPKG-10000-Theme/layout/${Theme === null ? 'DEFAULT' : Theme}/index.vue`),
    children: [
      // 變更密碼
      {
        path: '/changePassword',
        component: () => import(/* webpackChunkName: "EntertainmentAccount" */'./changePassword/modify.vue'),
        meta: {
          showToolbar:false,
          title: 'NODE_1',
        },
      },
      {
        path: 'manage/lists',
        name: 'manage-lists',
        component: () => import(/* webpackChunkName: "Account" */'@/modules/FPKG-40000-Account/manage/lists.vue'),
        meta: {
          title: 'NODE_2',
          url: 'account/manage/lists',
          toolbar: ['search', 'advSearch', 'pager', 'create', 'delete'],
        },
      },
      {
        path: 'manage/create',
        name: 'manage-create',
        component: () => import(/* webpackChunkName: "Account" */'@/modules/FPKG-40000-Account/manage/create.vue'),
        meta: {
          title: 'NODE_2',
          url: 'account/manage/lists',
          toolbar: ['keepCreate', 'saveAndGo'],

        },
      },
      {
        path: 'manage/info',
        name: 'manage-info',
        component: () => import(/* webpackChunkName: "Account" */'@/modules/FPKG-40000-Account/manage/info.vue'),
        meta: {
          title: 'NODE_2',
          url: 'account/manage/lists',
          toolbar: ['modify'],
        },
      },
      {
        path: 'manage/modify',
        name: 'manage-modify',
        component: () => import(/* webpackChunkName: "Account" */'@/modules/FPKG-40000-Account/manage/modify.vue'),
        meta: {
          title: 'NODE_2',
          url: 'account/manage/lists',
          toolbar: ['info', 'save'],
        },
      },
    ],
  },
];
